import downloadFile from './downloadFile.esm.js';
import makeCSV from './makeCSV.esm.js';

/**
 * Generates a CSV representation of the table and triggers a download for it.
 *
 * @param tableInstance
 * @param fileName
 */
function downloadCSV(tableInstance, fileName) {
    const file = makeCSV(tableInstance);
    downloadFile({ fileName, file });
}

export { downloadCSV };
//# sourceMappingURL=downloadTable.esm.js.map
